export default "__VITE_ASSET__0KkB_ZxA__"